var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSourceUserTrxData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47138 1.02257C3.83412 0.391635 4.51096 0.00754226 5.23864 0.0196931L8.05901 0.0667879L10.8799 0.0682217C11.6076 0.0685916 12.2777 0.464164 12.6296 1.10111L14.0016 3.58477L15.4179 6.05396C15.7775 6.68084 15.7709 7.45295 15.4007 8.0736L13.9426 10.518L12.5286 12.9774C12.1659 13.6084 11.489 13.9925 10.7614 13.9803L7.94099 13.9332L5.12006 13.9318C4.39238 13.9314 3.72232 13.5358 3.37045 12.8989L1.99839 10.4152L0.582107 7.94604C0.222538 7.31916 0.229127 6.54705 0.599343 5.9264L2.05739 3.48202L3.47138 1.02257Z",
    fill: "#4285F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2207_43290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5C9.5 7.33 8.83 8 8 8C7.17 8 6.5 7.33 6.5 6.5C6.5 5.67 7.17 5 8 5C8.83 5 9.5 5.67 9.5 6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C12 9.21 10.21 11 8 11C5.79 11 4 9.21 4 7C4 4.79 5.79 3 8 3C10.21 3 12 4.79 12 7ZM6 9.875C6.08 9.742 6.855 8.5 7.995 8.5C9.13 8.5 9.91 9.745 9.99 9.875C10.4549 9.55349 10.8348 9.12386 11.097 8.62306C11.3591 8.12226 11.4957 7.56527 11.495 7C11.495 5.065 9.93 3.5 7.995 3.5C6.06 3.5 4.495 5.065 4.495 7C4.495 8.19 5.09 9.245 6 9.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2207_43290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourceUserTrxData);
export default __webpack_public_path__ + "static/media/data_source_user_trx_data.b753e27ba5491c579080320584bb855f.svg";
export { ForwardRef as ReactComponent };